import { t } from 'i18next';
import { GenderMap } from 'models/profile';
import { appVersion, showUsaFeature, shortSha, isProduction } from './app';

export const PORTAL_VERSION = `v${showUsaFeature ? 'US' : 'EU'}-${appVersion}`;
export const PORTAL_FULL_VERSION = `v${showUsaFeature ? 'US' : 'EU'}-${appVersion}-${shortSha} ${!isProduction ? '(DEV)' : ''}`;
export const DRAWER_PADDING = 'md';
export const MAX_REPORTS_TOTAL = 40;
export const DEFAULT_ICON_SIZE = 20;
export const FUSDR_URL = 'https://help.fibricheck.com/hc/en-us/articles/16283296775836';

export const Z_INDEX_VALUES = {
  tableHeader: 210,
  drawer: 220,
  notifications: 230,
  modal: 240,
};

export const renderYesNoValue = (value?: string | boolean) => {
  switch (value) {
    case true:
      return t('yes_label');
    case false:
      return t('no_label');
    case 'true':
      return t('yes_label');
    case 'false':
      return t('no_label');
    default:
      return t('na_short_label');
  }
};

export const renderGenderLabel = (gender?: number): string => {
  return t(`${GenderMap.find((value) => value.code === gender)?.label}`) || t('not_applicable_label');
};

export const capitalizeFirstLetter = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};
